import { render, staticRenderFns } from "./chips.vue?vue&type=template&id=3b490f2e&scoped=true&"
import script from "./chips.vue?vue&type=script&lang=js&"
export * from "./chips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b490f2e",
  null
  
)

export default component.exports